import React from "react";
import { Music, Utensils, Users, Shirt, Camera, Heart } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const FestivalDescription: React.FC = () => {
  const { t } = useLanguage();

  const features = [
    {
      icon: <Music className="w-8 h-8" />,
      title: t.festivalDescription.featureMusic,
      description: t.festivalDescription.featureMusicDesc,
    },
    {
      icon: <Utensils className="w-8 h-8" />,
      title: t.festivalDescription.featureFood,
      description: t.festivalDescription.featureFoodDesc,
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: t.festivalDescription.featureDance,
      description: t.festivalDescription.featureDanceDesc,
    },
    {
      icon: <Shirt className="w-8 h-8" />,
      title: t.festivalDescription.featureCostumes,
      description: t.festivalDescription.featureCostumesDesc,
    },
    {
      icon: <Camera className="w-8 h-8" />,
      title: t.festivalDescription.featurePhoto,
      description: t.festivalDescription.featurePhotoDesc,
    },
    {
      icon: <Heart className="w-8 h-8" />,
      title: t.festivalDescription.featureAtmosphere,
      description: t.festivalDescription.featureAtmosphereDesc,
    },
  ];

  return (
    <section className="section bg-white">
      <div className="container-custom">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-romanian-red font-semibold text-sm uppercase tracking-wider">
            {t.festivalDescription.aboutFestival}
          </span>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-romanian-blue mt-2 mb-4">
            {t.festivalDescription.celebrationTitle}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-romanian-blue via-romanian-yellow to-romanian-red mx-auto" />
        </div>

        {/* Main Description */}
        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-gradient-to-br from-primary-50 to-white rounded-2xl p-8 md:p-12 shadow-lg border border-primary-100">
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              <span className="font-display text-2xl text-romanian-blue font-semibold">
                „Ca Pe Vremuri"
              </span>{" "}
              {t.festivalDescription.mainDesc1}
            </p>
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              {t.festivalDescription.mainDesc2}
            </p>
            <p className="text-gray-700 text-lg leading-relaxed mb-6">
              {t.festivalDescription.mainDesc3}
            </p>
            <p className="text-gray-700 text-lg leading-relaxed italic">
              {t.festivalDescription.mainDesc4}
            </p>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-romanian-yellow"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-romanian-blue to-primary-600 rounded-xl flex items-center justify-center text-white mb-4 group-hover:scale-110 transition-transform">
                {feature.icon}
              </div>
              <h3 className="font-semibold text-xl text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FestivalDescription;
